import { genericGet } from "../../../services/api.service";
import { EntityConfig } from "../../..";

export const NotasCreditoFornecedoresTableConfigs : EntityConfig = [
    {
        id: 'id',
        label: 'Id',
        type: 'id',
        nonEditable: true
      },
    {
      id: 'code',
      label: 'Nota de Crédito',
      type: 'text',
      filterable: true
    },
    {
      id: 'date',
      label: 'Data',
      type: 'date',
      filterable: true,

    },
    {
      id: 'supplier',
      label: 'Fornecedor',
      type: 'select',
      filterable: true,
      routable: true,
      options: {
        name: 'Fornecedor',
        route: 'fornecedores',
        value: 'id',
        label: 'name',
        getter: ()=>genericGet('/findByFilter/fornecedores'),
        searcheable: true
      }
    },
    {
        id: 'value',
        label: 'Valor',
        type: 'number',
        displayInfo: 'currency'
    },
    {
      id: 'faturacaoADescontar',
      label: 'Fatura a descontar',
      type: 'select',
      filterable: true,
      options: {
        route: 'faturacaoFornecedores',
        value: 'id',
        label: 'code',
        displayInfo: [{name: 'Fatura', label: 'code'}, {name: 'Valor', label: 'value', type: 'currency'}],
        // getter: ()=>genericGet('/findByFilter/faturacao-fornecedores'),
        triggeredGetter: (i : number)=>genericGet(`/faturacao-fornecedores/unpaid/${i}`), // function to trigger according to other form parameter
        triggerParam: 'supplier', // Form parameter used to build getterfunction
        searcheable: true

      }
    },
    {
      id: 'used',
      label: 'Usada',
      type: 'boolean',
      filterable: true,

  }
  ];
  